<template>
  <main-template>
    <v-row>
      <v-col>
        <span class="text-h4">Diário de Atendimentos — {{ titulo }}</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-alert type="info" text border="left" color="primary" class="mt-4">
          O submódulo <strong>{{ titulo }}</strong> será disponibilizado em breve.
        </v-alert>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
export default {
  name: "DiarioAtendimentosEmBreve",
  props: {
    titulo: {
      type: String,
      default: "Em desenvolvimento",
    },
  },
};
</script>

<style scoped></style>
